<template>
  <div>
    <v-card class="sf-card"
            flat>
      <div class="sf-card__header">
        <h2 class="sf-card__title">{{ $t('invitation') }}</h2>
      </div>
      <v-card-text class="sf-card__body">
        <v-form ref="form">
          <h3 class="sf-section-title">{{ $t('invitationCode') }}</h3>
          <p class="sf-code">{{ customer.invitationCode }}</p>
          <!--<v-text-field dense class="mb-4"
                        disabled
                        hide-details="auto"
                        outlined
                        v-bind:label="$t('invitationCode')"
                        v-bind:rules="[ rules.required ]"
                        v-model="customer.invitationCode" />-->
          <v-select dense class="mb-4"
                    hide-details="auto"
                    outlined
                    v-bind:items="states"
                    v-bind:label="$t('state')"
                    v-bind:rules="[ rules.required ]"
                    v-model="customer.state" />
          <!--<v-checkbox color="accent"
                          class="my-4"
                          hide-details="auto"
                          v-bind:label="$t('sendSamples')"
                          v-model="customer.sendSamples" />
          <v-checkbox color="accent"
                      class="my-0"
                      hide-details="auto"
                      v-bind:label="$t('onSiteFair')"
                      v-model="customer.onSiteFair" />-->
          <v-checkbox color="primary"
                      class="my-0"
                      hide-details="auto"
                      v-bind:label="$t('wasAttending')"
                      v-model="customer.wasAttending" />
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    computed: {
      rules() {
        return {
          required: v => !!v || this.$t('form.required')
        }
      },
      states() {
        return [
          {
            text: this.$t('open'),
            value: 'open'
          },
          {
            text: this.$t('invited'),
            value: 'invited'
          },
          {
            text: this.$t('accepted'),
            value: 'accepted'
          },
          {
            text: this.$t('declined'),
            value: 'declined'
          }
        ]
      }
    },
    methods: {
      validate() {
        return this.$refs.form.validate()
      }
    },
    name: 'CustomerInvitationEditCard',
    props: {
      customer: Object
    }
  }
</script>

<style scoped>
  .sf-code {
    background: var(--sf-surface-muted);
    border: 1px solid var(--sf-border);
    border-radius: 10px;
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: .9375rem;
    letter-spacing: .04em;
    margin-bottom: 20px;
    padding: 10px 14px;
    user-select: all;
  }
</style>

<i18n>
  {
    "de": {
      "accepted": "Angenommen",
      "declined": "Abgelehnt",
      "invitation": "Einladung",
      "invitationCode": "Einladungscode",
      "invited": "Eingeladen",
      "onSiteFair": "Zur Präsenzmesse einladen",
      "open": "Offen",
      "sendSamples": "Kostprobenpaket versenden",
      "state": "Status",
      "wasAttending": "Hat teilnehmen"
    },
    "en": {
      "accepted": "Accepted",
      "declined": "Declined",
      "invitation": "Invitation",
      "invitationCode": "Invitation code",
      "invited": "Invited",
      "onSiteFair": "Invite to on site fair",
      "open": "Open",
      "sendSamples": "Send samples",
      "state": "State",
      "wasAttending": "Was attending"
    }
  }
</i18n>